














































































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { AssessmentForm } from "@/entities";
import ProgressBar from '@/components/common/ProgressBar/ProgressBar.vue';
import WorkflowButtons from '@/components/common/ProgressBar/WorkflowButtons.vue';
import { Utilities as utils } from "@/shared/utilities";
import { AppConstants as _app } from "@/shared/app.constants";
import { Locales } from "@/i18n/locales";

const namespace: string = "assessmentForm";

@Component({
    components: {
        ProgressBar,
        WorkflowButtons
    }
})
export default class GpouSummaryComponent extends Vue {
  @State(namespace) form!: AssessmentForm;
  @Action("submit", { namespace }) submitReviewData: any;
  @Action("getData", { namespace }) getData: any;
  @Action("getDataByApplication", { namespace }) getDataByApplication: any;
  @Action("getTemplate", { namespace }) getTemplate: any;
  @Action("resetTabs", { namespace }) resetActiveTabs: any;
  @Action("saveApplication", { namespace: "application" }) save: any;
  @Action("showNotification", { namespace: "application" }) showNotification: any;
  @Action("getApplicationSection", { namespace }) getApplication: any;

  schema = _app.internalReviewTemplate;
  reviewId: number = 0;
  showFlow = false;
  // appSummary={};
  // techApplnData: any = {};
  entity: string;
  defaultLocale: string = localStorage.getItem("language") || Locales.EN;

  /** mount fn */
  mounted() {
    // this.getTemplate(1);
    // #. handle the page refresh (redirect to dashboard)
    // if((this.form) && !(this.form.internalReviewId)) {
    //   this.$router.push({
    //     name: "internalReviews"
    //   });
    // }
  }

  get appSummary() {
    return this.form.applicationSection.appHeader;
  }
  get techApplnData() {
    return this.form.applicationSection.data;
  }

  /** open a read only view of application in new tab */
  openApplication(applicationId) {
    if (this.entity == "ConceptNote") {
      let routeData = this.$router.resolve({
        name: "viewConceptNote",
        params: { conceptNoteId: applicationId, section: 'technicalApplication' }
      });
      window.open(routeData.href, "_blank");
    }
    else {
      let routeData = this.$router.resolve({
        name: "viewApplication",
        params: { appId: applicationId, section: 'technicalApplication' }
      });
      window.open(routeData.href, "_blank");
    }
  }

  /*submitReview(context: string) {
    switch (context) {
      case 'dueDiligence':
        let summary = this.$services.reviewinternal.dueDiligenceSummary(
          this.form.dueDeliganceAssessment.templates,
          this.form.dueDeliganceAssessment.data
        );
        if (summary.propsCount != summary.filledProps) {
          this.showNotification(
            {
              text: "Please score all sections to proceed",
              color: "error"
            }
          )
        } else {
          this.submitSection(
            this.form.internalReviewId,
            this.form.dueDeliganceAssessment.data,
            context);
        }
        break;
    
      case 'budget':
        let result = this.$services.reviewinternal.budgetSummary(
          this.form.budgetAssessment.templates,
          this.form.budgetAssessment.data
        );
        if (result.propsCount != result.filledProps) {
          this.showNotification(
            {
              text: "Please score all sections and provide a conclusion to proceed",
              color: "error"
            }
          )
        } else {
          this.submitSection(
            this.form.internalReviewId,
            this.form.budgetAssessment.data,
            context);
        }
        break;
    }
  }*/

  /*submitSection(id, datum, context) {
    this.submitReviewData({
        id: id,
        data: datum,
        context
      })
      .then((data) => {
          if(data) {
            // this.getData(this.form.internalReviewId)
              const key: any = 'intReviewSubmitted';
              this.$router.push({
                  name: "genericNotification",
                  query: { msgId: key }
              });
          }
      });
  }*/

  /*hideButton(key: string) {
    let hide = false;
    switch(key) {
      case 'dueDiligence':
        if(this.form.reviewHeader && this.form.reviewHeader.DDReviewSubmitted && this.form.reviewHeader.DDReviewSubmitted == 1) {
          hide = true;
        }
        break;
      case 'budget':
        if(this.form.reviewHeader && this.form.reviewHeader.BudgetReviewSubmitted && this.form.reviewHeader.BudgetReviewSubmitted == 1) {
          hide = true;
        }
        break;
        
    }
    return hide;
  }*/

  openSection(key: any) {
      let routeData;
    if (key === 'dueDiligence') {
        routeData=this.$router.resolve({
          name: "ReadonlyinternalReview",
        });
    } else if(key === 'budget') {
        routeData =this.$router.resolve({
          name: "readOnlyBudgetReview",
        });
    }
     window.open(routeData.href, "_blank");
  }

  /*buttonAction(value: any) {
    this.appSummary["WorkflowStatusId"] = value.StepId;
        return this.save({
                  data: this.appSummary,
                  id: this.appSummary["ApplicationId"],
                  context: 'submit'
                })
                .then(() => {
                  this.$router.push({
                      name: "dashboard"
                  });
                });
  }*/

  get warningText() {
    let text = "";
    if (this.techApplnData && this.techApplnData['haveIndividualNamedAccount'] === 'Yes') {
      text = "* The organisation has bank accounts held in the name of individuals "
    }
    return text;
  }

  get workFlowItems() {
    return this.appSummary['WorkflowInfo'];
  }

  get budgetStatus(): any {
    if (this.form.budgetAssessment.data && this.form.budgetAssessment.data.conclusion) {
      return (this.form.budgetAssessment.data.conclusion == 1)? this.$t("Accepted") : (this.form.budgetAssessment.data.conclusion == 2)? this.$t("Revisions required") : this.$t("Not recommended");
    }
  }

  get ddStatus() {
    if (this.form.dueDeliganceAssessment.data && this.form.dueDeliganceAssessment.data.conclusion) {
      return (this.form.dueDeliganceAssessment.data.conclusion == 1)? this.$t("Recommend for funding") : (this.form.dueDeliganceAssessment.data.conclusion == 2)? this.$t("Recommend for funding if additional documents/information is provided") : this.$t("Do NOT Recommend for funding");
    }
  }

  get totalRating(): any {
    if (this.form.dueDeliganceAssessment.data) {
      return Object.keys(this.form.dueDeliganceAssessment.data).reduce((total, key) => {
        if(this.form.dueDeliganceAssessment.data[key] && this.form.dueDeliganceAssessment.data[key].score){
          total = total + parseInt(this.form.dueDeliganceAssessment.data[key].score);
        }
        return total;
      },0);
    } else {
      return 0;
    }
  }

  get riskLevel(): any {
    return (this.totalRating <= 25)? this.$t("LOW") : (this.totalRating <= 40)? this.$t("MEDIUM") : this.$t("HIGH");

  }

  /** watch methods */
  @Watch("form.reviewHeader")
  statusCheck(value: any) {
    if (
          this.form.reviewHeader
          && this.form.reviewHeader.BudgetReviewSubmitted
          && this.form.reviewHeader.BudgetReviewSubmitted == 1
          && this.form.reviewHeader.DDReviewSubmitted
          && this.form.reviewHeader.DDReviewSubmitted == 1
        ) {
          this.showFlow = true;
        }
  }

  @Watch("$route", { immediate: true, deep: true })
  onUrlChange(changedRoute: any) {
    if(changedRoute && changedRoute.name === 'readOnlyInternalReviewSummary') {
      this.resetActiveTabs();
      
      if (this.$route.params && this.$route.params.applicationId) {
        let id = parseInt(this.$route.params.applicationId);
        this.entity = this.$route.params.entity;
        this.getDataByApplication({id: id, entity: this.entity});
        this.getApplication({id: id, entity: this.entity});
      }

      // if(this.form && this.form.internalReviewId) {
      //   this.getData(this.form.internalReviewId).then((res) => {
      //     this.getApplication({id: res.applicationId});
      //     /*this.$services.application.getApplicationData(res.applicationId).then((data) => {
      //       if (data && data.ApplicationId) {
      //         this.appSummary = data;
      //         this.$services.application.getTechnicalApplication(data.ApplicationId).then((res) => {
      //           this.techApplnData = res;
      //         });
      //       }
      //     });*/
      //   })
      // }
    }
  }

  formatCurrency(val, currency) {
    return utils.formatCurrency(val, currency, this.defaultLocale);
  }
}
